export type IBppFormSixthSectionInterface = {
    MarketValue?: string,
}


export const SixthSectionInitialState = {
    MarketValue: undefined
}